
import {BASE_PATH} from "../../../../custom/axios/config/Url";
import {DG_axios} from "../../../../custom/axios";
import {DG_axiosNormal} from "../../../../custom/axios/normal";

const BASE_URI = `${BASE_PATH}/dogoo/formular-config-rest/v2.0/formula-Keywords`;
const BASE_URL = `${BASE_PATH}/dogoo/formular-config-rest/v2.0/timekeeping-Formula-Configs`;
const BASE_URT = `${BASE_PATH}/dogoo/formular-config-rest/v2.0/timesheet-formulas`;
const BASE_URH = `${BASE_PATH}/dogoo/formular-config-rest/v2.0/standard-workdays`;
const BASE_REPORT = `${BASE_PATH}/dogoo/timekeeping-rest/v2.0/statistical-report-timekeeping-echart`;
const BASE_REPORT_OVER_VIEW = `${BASE_PATH}/dogoo/timekeeping-rest/v2.0/statistical-report-timekeeping-overview`;
const BASE_REPORT_OVER_Detail = `${BASE_PATH}/dogoo/timekeeping-rest/v2.0/statistical-report-timekeeping-detail`;

export async function getFormulaKeyword(type){
    const response = await DG_axios.get(`${BASE_URI}?type=${type}`)
    return response?.data || []
};

export async function getTimekeepingFormula(){
    const response = await DG_axios.get(`${BASE_URL}`)
    return response?.data || []
};

export async function postTimekeepingFormula(value){
    const response = await DG_axiosNormal.post(`${BASE_URL}` , value)
    return response?.data || []
};

export async function deleteTimesheetFormula(id){
    const response = await DG_axiosNormal.delete(`${BASE_URT}/${id}`)
    return response?.data || []
};

export async function deleteStandardWorkday (id){
    const response = await DG_axiosNormal.delete(`${BASE_URH}/${id}`)
    return response?.data || []
};

export async function reportTimeKeepingEchart(params , url){
    const config = {params: params};
    const response = await DG_axios.get(BASE_REPORT + url, config);

    return response.data || []
}
export async function reportTimeKeepingOverview(params,url){
    const config = {params: params};
    const response = await DG_axios.get(BASE_REPORT_OVER_VIEW + url, config);

    return response.data || []
}export async function reportTimeKeepingDetail(params,url){
    const config = {params: params};
    const response = await DG_axios.get(BASE_REPORT_OVER_Detail + url, config);

    return response.data || []
}